import { render, staticRenderFns } from "./login.vue?vue&type=template&id=a4d63d48&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=a4d63d48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d63d48",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputsInput: require('/var/www/jaty-frontend/components/inputs/Input.vue').default,FacebookButton: require('/var/www/jaty-frontend/components/FacebookButton.vue').default,AuthFormSecondaryLink: require('/var/www/jaty-frontend/components/AuthFormSecondaryLink.vue').default})
